module.exports = __webpack_public_path__ + "static/media/volley.e774d76e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/volley.svg
// module id = 404
// module chunks = 7